import React, { createContext, useContext, useEffect, useRef } from 'react';
import appInsightsService from './appInsights.service';

interface AppInsightsContextValue {
  isInitialized: boolean;
}

const AppInsightsContext = createContext<AppInsightsContextValue>({
  isInitialized: false,
});

export const useAppInsightsContext = () => useContext(AppInsightsContext);

interface AppInsightsProviderProps {
  children: React.ReactNode;
  connectionString?: string;
}

export const AppInsightsProvider: React.FC<AppInsightsProviderProps> = ({
  children,
  connectionString,
}) => {
  const isInitializedRef = useRef(false);

  useEffect(() => {
    // Prevent double initialization in StrictMode
    if (isInitializedRef.current) return;

    const connStr = connectionString || import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING;

    if (!connStr) {
      console.warn('[AppInsightsProvider] No connection string provided. Telemetry disabled.');
      return;
    }

    appInsightsService.init(connStr);
    isInitializedRef.current = true;
  }, [connectionString]);

  const contextValue: AppInsightsContextValue = {
    isInitialized: appInsightsService.isInitialized(),
  };

  return (
    <AppInsightsContext.Provider value={contextValue}>
      {children}
    </AppInsightsContext.Provider>
  );
};

export default AppInsightsProvider;
